import React from "react";
import i18n from "utils/i18n";
import _ from 'lodash'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Form, { createTranslationField } from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { FormFieldsConstants, FormStatus } from 'utils/constants/form-constants'
import PreviewTimeslotKind from 'scenes/management/timeslots/timeslot_kind/_components/PreviewTimeslotKind'
import VStack from 'components/atoms/stack/VStack'
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import { useShowHamburger } from "utils/helper-device";
import GraphqlBuilder, { graphqlOptions } from "utils/request/graphql/builder";
import MutateTranslation from "utils/mutate/translation";
import { tableConstants } from "utils/constants/constants";
import { useNavigation, useRoute } from "@react-navigation/native";
import { AppRoutes } from "navigations/app-routes";
import FetchCreditBundles from "utils/fetch/FetchCreditBundles";
import useFetch from "utils/hooks/useFetch";
import MutationManagementTimeslotKind from "graphql/mutations/management/MutationManagementTimeslotKind";
import MutationManagementCreditBundle from "graphql/mutations/management/MutationManagementCreditBundle";
import useRouteParameters from "utils/hooks/use-route-parameters";
import Translate from "utils/translate";

const ManagementCreditBundlesEdit = ( { updateTimeslotKind, timeslotKind, isSaving }) => {

	const route = useRoute();
	const _routeParameters = useRouteParameters( route );

	const navigation = useNavigation();
	const showHamburger = useShowHamburger();
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	const _timeslotKinds = useSelector(state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );

    const { data: creditBundle, loading, refetch } = useFetch( FetchCreditBundles.fetch, {
		variables: {
			guid: _routeParameters?.creditBundleGuid
		}
	} );

	const saveForm = ( values, { callback } = {} ) => {
		new GraphqlBuilder( { [ graphqlOptions.processVariables ]: false })
			.addQuery( 'mutation', MutationManagementCreditBundle, values )
			.setResultPath( ['mutation', 'credit_bundle'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				MutateTranslation.mutate( tableConstants.CREDIT_BUNDLES, result.guid, values, {
					callbackSuccess: ( t ) => {
						callback( FormStatus.SUCCESS );
						
						// FetchCachedTimeslotKinds.reload();
						
						if( _.get( timeslotKind, 'guid' ) !== result.guid ){
							navigation.replace( AppRoutes.MANAGEMENT_CREDIT_BUNDLES_EDIT, {
								creditBundleGuid: result.guid,
							});
						}else{
							refetch()
						}
					},
					callbackError: () => {
						callback( FormStatus.ERROR )
					}
				} )
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	const formFields = [
		{
			name: 'name',
			required: true,
			label: i18n.t('management:form.name.system_name'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'credits_amount',
			required: true,
			label: i18n.t('management:form.credit_amount.title'),
			type: FormFieldsConstants.NUMBER,
		},
		{
			name: 'price',
			required: true,
			label: i18n.t('management:form.price.title'),
			type: FormFieldsConstants.NUMBER,
		},
		{
			name: 'timeslot_kind_guid',
			label: i18n.t('management:form.timeslot_kinds.title'),
			type: FormFieldsConstants.SELECT,
			options: _.map( _timeslotKinds, ( timeslotKind ) => {
				return {
					value: timeslotKind.guid,
					label: timeslotKind.name
				}
			})
		},
		{
			name: 'status',
			label: i18n.t('management:form.status.title'),
			type: FormFieldsConstants.SELECT,
			options: [
				{ value: 'active', label: i18n.t('management:form.status.active') },
				{ value: 'inactive', label: i18n.t('management:form.status.inactive') },
			]
		},
		{
			type: FormFieldsConstants.DIVIDER
		}
	];
	
	// Add the translations
	if( _.size( _languages ) > 0 ) {
		formFields.push( {
			type: FormFieldsConstants.DIVIDER
		} );
		
		// Add the translation fields
		_.forEach( _languages, ( language ) => {
			let { name, formField } = createTranslationField( 'name', language );
			formFields.push( formField );

			const translation = Translate.formField( creditBundle, 'title', language );
			if( translation !== null ) {
				creditBundle[ name ] = translation;
			}
		});
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t( 'management:pages.credits.title')}
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>

				{ !loading && (
					<VStack>
						<ThemedBlock
							shadow
							mediumPadding>
							
							<Form
								values={{
									...creditBundle,
									timeslot_kind_guid: _.get( creditBundle, 'timeslot_kind.guid', '' )
								}}
								fields={ formFields }
								onChange={ updateTimeslotKind }
								onSubmit={ saveForm }
								disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) || isSaving }
								forceSaveButton={ true }
							/>
						</ThemedBlock>
					</VStack>
				)}
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementCreditBundlesEdit
